var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFa6SolidLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa6-solid:link",
    clipPath: "url(#clip0_1860_3752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6831 6.2508C13.919 5.03693 13.919 3.07111 12.6831 1.85724C11.5893 0.783021 9.86559 0.643373 8.60778 1.52638L8.57278 1.55001C8.25778 1.7713 8.1856 2.20099 8.41091 2.50822C8.63622 2.81544 9.07372 2.88849 9.38653 2.6672L9.42153 2.64357C10.1237 2.15158 11.084 2.22892 11.6922 2.82833C12.3812 3.50509 12.3812 4.60079 11.6922 5.27755L9.23778 7.6924C8.54872 8.36915 7.43309 8.36915 6.74403 7.6924C6.13372 7.09298 6.05497 6.14982 6.55591 5.46232L6.57997 5.42794C6.80528 5.11857 6.73091 4.68888 6.4181 4.46974C6.10528 4.2506 5.6656 4.3215 5.44247 4.62872L5.41841 4.6631C4.51716 5.8963 4.65935 7.58927 5.7531 8.66349C6.98903 9.87736 8.99059 9.87736 10.2265 8.66349L12.6831 6.2508ZM1.31685 5.74806C0.0809082 6.96193 0.0809082 8.92775 1.31685 10.1416C2.4106 11.2158 4.13435 11.3555 5.39216 10.4725L5.42716 10.4488C5.74216 10.2276 5.81435 9.79786 5.58903 9.49064C5.36372 9.18341 4.92622 9.11036 4.61341 9.33165L4.57841 9.35529C3.87622 9.84728 2.91591 9.76994 2.30778 9.17052C1.61872 8.49162 1.61872 7.39591 2.30778 6.71915L4.76216 4.30646C5.45122 3.6297 6.56685 3.6297 7.25591 4.30646C7.86622 4.90587 7.94497 5.84904 7.44403 6.53869L7.41997 6.57306C7.19466 6.88244 7.26903 7.31212 7.58185 7.53126C7.89466 7.7504 8.33435 7.67951 8.55747 7.37228L8.58153 7.3379C9.48278 6.10255 9.3406 4.40958 8.24685 3.33537C7.01091 2.1215 5.00935 2.1215 3.77341 3.33537L1.31685 5.74806Z",
    fill: "#010048",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1860_3752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 11,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFa6SolidLink);
export default __webpack_public_path__ + "static/media/fa6-solid_link.cdc10f0f4680528e354bb70c17b2b2c8.svg";
export { ForwardRef as ReactComponent };